import { render, staticRenderFns } from "./InventoryVehicle.vue?vue&type=template&id=083bdf25&"
import script from "./InventoryVehicle.vue?vue&type=script&lang=js&"
export * from "./InventoryVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports